module.exports = __webpack_public_path__ + "img/veg-sticky.9faa7c68.svg";